import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="dependent-fields"
export default class extends Controller {
    static targets = ["triggerField", "dependentField"]

    connect() {
        this.updateAllDependents()
    }

    handleFieldChange(event) {
        this.updateAllDependents()
    }

    updateAllDependents() {

        this.triggerFieldTargets.forEach(trigger => {
            const triggerName = trigger.dataset.triggerField;
            const triggerValue = trigger.value;

            this.dependentFieldTargets.forEach(dependent => {
                const parentName = dependent.dataset.dependentParent;
                if (parentName === triggerName) {
                    this.updateChildOptions(dependent, triggerValue);
                }
            });
        });
    }

    updateChildOptions(childElement, parentValue) {
        const mappings = JSON.parse(childElement.dataset.dependentMapping);
        const condition = mappings.find(c => c.value === parentValue);
        const options = condition ? condition.choices : [];
        const originalValue = childElement.dataset.originalValue;

        const tomselectInstance = childElement.tomselect;

        if (!tomselectInstance) {
            console.error("TomSelect instance not found on dependent field:", childElement);
            // Fallback to direct DOM manipulation if TomSelect isn't initialized
            childElement.innerHTML = "";
            if (options.length === 0) {
                const defaultOption = document.createElement("option");
                defaultOption.text = "Select a value";
                defaultOption.value = "";
                childElement.add(defaultOption);
                childElement.disabled = true;
                return;
            }
            childElement.disabled = false;
            const defaultOption = document.createElement("option");
            defaultOption.text = "Select an option";
            defaultOption.value = "";
            childElement.add(defaultOption);
            options.forEach(optionValue => {
                const option = document.createElement("option");
                option.text = optionValue;
                option.value = optionValue;
                if (optionValue === originalValue) {
                    option.selected = true;
                }
                childElement.add(option);
            });
            return;
        }

        tomselectInstance.clearOptions();

        if (options.length === 0) {
            tomselectInstance.addOption({ value: "", text: "Select a value" });
            tomselectInstance.setValue("");
            tomselectInstance.disable();
            return;
        }

        tomselectInstance.enable();
        tomselectInstance.addOption({ value: "", text: "Select an option" });

        options.forEach(optionValue => {
            tomselectInstance.addOption({ value: optionValue, text: optionValue });
        });

        if (originalValue && options.includes(originalValue)) {
            tomselectInstance.setValue(originalValue);
        } else {
            tomselectInstance.setValue("");
        }
    }
}
